export default "__VITE_ASSET__BD6Qk$CO__";